import React from "react";
import styles from "./Infotip.less";
import cx from "classnames";
export function Infotip(props) {
  return React.createElement("span", {
    className: cx(styles.tip, props.className)
  }, React.createElement("i", {
    className: cx(styles.tipIcon, "fa fa-question-circle"),
    "aria-hidden": "true"
  }), React.createElement("small", {
    className: styles.tipText
  }, props.children, props.title));
}